/**
 * Configuração centralizada da versão da aplicação
 * Este arquivo é atualizado automaticamente pelos scripts de versionamento
 */

export const APP_VERSION = '2.4.15';

/**
 * Retorna a versão formatada para exibição
 * @param {boolean} includePrefix - Se deve incluir o prefixo 'v'
 * @returns {string} Versão formatada
 */
export const getFormattedVersion = (includePrefix = true) => {
  return includePrefix ? `v${APP_VERSION}` : APP_VERSION;
};

/**
 * Retorna informações da versão
 * @returns {object} Objeto com informações da versão
 */
export const getVersionInfo = () => {
  const [major, minor, patch] = APP_VERSION.split('.').map(Number);
  
  return {
    version: APP_VERSION,
    major,
    minor,
    patch,
    formatted: getFormattedVersion(),
    buildDate: new Date().toISOString().split('T')[0]
  };
};

export default APP_VERSION;
